<app-slider
  [loop]="true"
  [navigation]="true"
  [slides]="slides"
  [spaceBetween]="20"
>
</app-slider>
